var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_12056"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Twitter",
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Twitter",
    width: 16,
    height: 16,
    fill: "currentColor",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_12056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.03 14.5C11.06 14.5 14.37 9.49 14.37 5.15C14.37 5.01 14.36 4.87 14.36 4.73C15 4.26 15.55 3.69 16 3.03C15.41 3.29 14.77 3.46 14.11 3.54C14.79 3.14 15.31 2.49 15.55 1.73C14.91 2.11 14.2 2.38 13.47 2.52C12.87 1.89 12.02 1.49 11.07 1.49C9.26 1.49 7.79 2.96 7.79 4.77C7.79 5.03 7.82 5.28 7.88 5.52C5.15 5.38 2.73 4.07 1.11 2.09C0.82 2.59 0.66 3.16 0.66 3.74C0.66 4.88 1.24 5.88 2.12 6.47C1.6 6.46 1.09 6.32 0.64 6.06C0.64 6.08 0.64 6.09 0.64 6.1C0.64 7.69 1.77 9.02 3.27 9.32C2.99 9.4 2.7 9.44 2.41 9.44C2.19 9.44 1.99 9.42 1.79 9.38C2.21 10.69 3.42 11.63 4.86 11.66C3.73 12.54 2.32 13.07 0.78 13.07C0.52 13.07 0.25 13.05 0 13.02C1.45 13.95 3.17 14.5 5.03 14.5L5.03 14.5Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.409863827f6cd4a9680ed4ce0d8abc5f.svg";
export { ForwardRef as ReactComponent };